"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _react = require("react"),
    ReduxFirestoreContext = (0, _react.createContext)(null),
    _default = ReduxFirestoreContext;

exports.default = _default, module.exports = exports.default;